export default __webpack_public_path__ + "static/media/magazine-placeholder.b3bd6193.jpg";